import { SpeakerIcon } from './Icons'

const Footer = () => {
  const buildEnv = process.env.REACT_APP_BUILD_ENV
  const buildNum = process.env.REACT_APP_BUILD_NUM
  const buildTime = process.env.REACT_APP_BUILD_TIME
  const supportLink = process.env.REACT_APP_AERO_SUPPORT_LINK

  const year = new Date().getFullYear()

  return (
    <footer className="relative px-4 h-12 min-w-full flex items-center bg-gm-blue dark:bg-neutral-80 text-neutral-10 justify-between">
      <div className="flex ">GM Motorsports Aero version 1.0</div>
      {buildEnv && (
        <div>
          Build: {buildEnv}-{buildNum} @ {buildTime}
        </div>
      )}
      <div className="flex items-center space-x-2">
        <span>{`©General Motors ${year}. All Rights Reserved.`}</span>
        {supportLink && <span className="text-xs">|</span>}
        {supportLink && (
          <a
            href={supportLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-1">
            <SpeakerIcon className="w-4 h-4 fill-white" />
            <span>Feedback</span>
          </a>
        )}
      </div>
    </footer>
  )
}

export default Footer
